// src/features/tasks/components/TaskListPage/TasksDataGrid/components/PriorityCell.jsx
import React from 'react';
import { Chip } from '@mui/material';
import { getPriorityColor } from '../../../../utils/taskStateUtils';
import { useTranslation } from 'react-i18next';

export default function PriorityCell({ value, row }) {
  const { t } = useTranslation("tasks");
  const priorityColor = getPriorityColor(value);
  return (
    <Chip
      label={t(`tasks:priority.${value.toLowerCase()}`)}
      size="small"
      color={priorityColor}
      sx={{
        minWidth: 90,
      }}
    />
  );
}